module.exports = __webpack_public_path__ + "static/media/pytorch.907fd1cb.svg";